import { subscribeToLeaderboardUpdates } from '@/lib/leaderboard-sync';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useLeaderboardSync(): void {
  const queryClient = useQueryClient();

  useEffect(
    () =>
      subscribeToLeaderboardUpdates(() => {
        void queryClient.invalidateQueries({
          predicate: ({ queryKey }) =>
            queryKey.some((key) => typeof key === 'string' && key.includes('leaderboard')),
        });
      }),
    [queryClient]
  );
}
